(() => {
  const source = document.querySelector('[data-roaming-image]');
  const button = document.querySelector('[data-roaming-toggle]');
  if (!source || !button) return;
  const reduced = matchMedia('(prefers-reduced-motion: reduce)');
  const fine = matchMedia('(hover: hover) and (pointer: fine)');
  const hand = document.createElement('img');
  hand.src = source.dataset.roamingImage; hand.alt = ''; hand.className = 'roaming-hand';
  hand.setAttribute('aria-hidden', 'true'); document.body.append(hand);
  const cursor = hand.cloneNode(); cursor.className = 'hand-cursor'; document.body.append(cursor);
  let enabled = true, frame, elapsed = 0, last = 0;
  try { enabled = localStorage.getItem('vice-roaming') !== 'off'; } catch {}
  function tick(time) {
    elapsed += last ? Math.min(time - last, 50) : 0; last = time;
    const size = hand.offsetWidth, margin = 12;
    const top = Math.min(130, innerHeight * .24);
    const width = Math.max(0, innerWidth - size - margin * 2);
    const height = Math.max(0, innerHeight - size - top - 30);
    const phase = elapsed / 1000;
    const x = margin + width * (.5 + .48 * Math.sin(phase * .12));
    const y = top + height * (.5 + .47 * Math.sin(phase * .173 + 1));
    hand.style.transform = `translate(${x}px,${y}px) rotate(${Math.sin(phase * 8) * 5}deg)`;
    frame = requestAnimationFrame(tick);
  }
  function sync() {
    cancelAnimationFrame(frame); last = 0;
    const active = enabled && !reduced.matches && document.body.dataset.motion !== 'false';
    hand.hidden = !active;
    button.setAttribute('aria-pressed', String(active));
    button.textContent = active ? button.dataset.on : button.dataset.off;
    if (active && !document.hidden) frame = requestAnimationFrame(tick);
  }
  button.addEventListener('click', () => {
    enabled = !enabled;
    try { localStorage.setItem('vice-roaming', enabled ? 'on' : 'off'); } catch {}
    sync();
  });
  function hideCursor() { cursor.hidden = true; document.documentElement.classList.remove('hand-cursor-active'); }
  document.addEventListener('pointermove', event => {
    if (!fine.matches || event.pointerType !== 'mouse' || document.querySelector('dialog[open]') || event.target.closest('input,textarea,select,[contenteditable]')) return hideCursor();
    cursor.hidden = false;
    document.documentElement.classList.add('hand-cursor-active');
    cursor.style.transform = `translate(${event.clientX - 12}px,${event.clientY - 8}px)`;
  });
  document.documentElement.addEventListener('pointerleave', hideCursor);
  document.addEventListener('keydown', hideCursor);
  window.addEventListener('blur', hideCursor);
  document.addEventListener('visibilitychange', sync);
  reduced.addEventListener('change', sync);
  hideCursor(); sync();
})();
